import React from 'react';
import { resolveAssetUrl } from '../../../shared/utils/assetUrl';
import '../styles/character.css';

/**
 * Cross positions from character.png (viewer's perspective looking at the character).
 * LEFT_HAND  = character's left hand = viewer's LEFT  side of image
 * RIGHT_HAND = character's right hand = viewer's RIGHT side of image
 * LEFT_LEG   = character's left leg  = viewer's LEFT
 * RIGHT_LEG  = character's right leg = viewer's RIGHT
 *
 * Render order (back → front): legs, body, hands, head
 */
// upper body (body, arms, head) sits 3% lower so the torso overlaps the hips instead of floating above the legs
export const PART_LAYOUT = [
  { key: 'rightLegModule',   left: '65%', top: '73%', size: '26%', z: 1 },
  { key: 'leftLegModule',    left: '33%', top: '73%', size: '26%', z: 1 },
  { key: 'bodyModule',       left: '50%', top: '41%', size: '46%', z: 2 },
  { key: 'rightHandModule',  left: '76%', top: '50%', size: '26%', z: 3 },
  { key: 'leftHandModule',   left: '26%', top: '50%', size: '26%', z: 3 },
  { key: 'headModule',       left: '50%', top: '17%', size: '48%', z: 4 },
];

export default function CharacterAssemblyPreview({ character }) {
  return (
    <div className="char-assembly-wrap">
      <img
        className="char-assembly-silhouette"
        src="/inventory/character.png"
        alt="character"
      />
      {PART_LAYOUT.map(({ key, left, top, size, z }) => {
        const mod = character?.[key];
        if (!mod) return null;
        return (
          <img
            key={key}
            className="char-assembly-part"
            src={resolveAssetUrl(mod.imageUrl)}
            alt={mod.name || key}
            style={{ left, top, width: size, zIndex: z }}
          />
        );
      })}
    </div>
  );
}
